import uuid from 'uuid/v4';
import noop from 'lodash/noop';
import { citations } from '@Constants';
import SocketBroker from '@Services/SocketBroker';
import { RxSocketUrls } from '@Constants/CommonConstants';

const buildQueryFactItem = ({ familyId, databaseId }) => {
  return {
    id: 'root',
    facts: [
      {
        id: 'ADVANCED.QL',
        exist: false,
        advancedItems: [
          {
            advancedExpression: `PBIB.FAMID=${familyId}`,
            databaseId,
          },
        ],
      },
    ],
  };
};

const runSearch = ({ searchId, requestId, queryFactItem, context, databases = [] }) => {
  const params = {
    queryFactItem,
    context,
    databases,
    searchId,
    requestId,
  };
  let searchFinished = false;
  let searchCanceled = false;
  let searchCancel = noop;

  // Callback for WS
  const searchHandler =
    (resolve) =>
    ({ payload = {} }) => {
      const {
        searchId: payloadSearchId,
        resultName,
        resultSize: resultsCount, // We get resultSize from BE, but PriorityWatcher uses resultsCount ...
      } = payload;

      if (searchId !== payloadSearchId || !resultName) {
        return;
      }

      searchFinished = true;
      resolve({ ...payload, resultsCount });
      searchCancel();
    };

  const promise = new Promise((resolve, reject) => {
    try {
      Logger.info('Reaxys Examples Search request:', params);

      // Subscribe to WS
      const unsubscribe = SocketBroker.observe(RxSocketUrls.ChannelsUrls.SearchInfo, searchHandler(resolve));

      // Send WS
      SocketBroker.send({ send: RxSocketUrls.AdvancedQuery }, { searchId, params });

      // Cancel WS / Unsubscribe
      searchCancel = () => {
        if (searchCanceled) {
          return;
        }
        searchCanceled = true;
        if (!searchFinished) {
          SocketBroker.send({ send: RxSocketUrls.CancelSearch }, { searchId });
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Search cancelled');
        }
        unsubscribe();
      };
    } catch (error) {
      reject(error);
    }
  });

  return {
    promise,
    cancel: searchCancel,
  };
};

// eslint-disable-next-line import/prefer-default-export
export const searchPatentFamily = ({ document, metadata }) => {
  const { familyId } = document;
  const { databaseId } = metadata;
  const searchId = uuid();
  const requestId = uuid();
  const queryFactItem = buildQueryFactItem({ familyId, databaseId });
  const context = citations;
  const databases = [databaseId];

  return runSearch({ searchId, requestId, queryFactItem, context, databases });
};
